/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import { AutoMailActionTypes } from '../../action/auto_action/AutoMailActions'
import SmtpSettingOptionState from './state/SmtpSettingOptionState'

class SmtpSettingOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AutoMailActionTypes.fetchSmtpSettings:
        const smtp_settings = payload.smtp_settings.map(smtp_setting => {
          return new SmtpSettingOptionState().mergeModel(smtp_setting)
        })
        return List(smtp_settings)
      default:
        return state
    }
  }
}

export default new SmtpSettingOptionsStore()
